import { createSlice } from "@reduxjs/toolkit";
import {
  me,
  getUserFromSession,
  update,
  getPreferences,
  getProfilePicture,
  setProfilePicture,
  getAccountValues,
  toggleAvTracking,
  toggleEmailOptin,
  toggleFeatureFlags,
  updatePreferredCurrency,
  updatePreferredTwoFAMethod,
  setUsername,
  checkUsernameAvailability,
  getPublicProfile,
} from "./thunks";
import { logout, expiredLogout, authenticate, confirm2FA, googleSSO } from "../auth/thunks";
import { confirmPayment } from "../payments/thunks";
import {
  addAsyncLifecycleCases,
  addFulfilledCases,
  setField,
} from "../utils/asyncHandlers";

const initialState = {
  user: {},
  preferences: {},
  profilepic: {},
  accountValues: {},
  publicProfile: {},
  publicProfileLoading: false,
  publicProfileError: false,
  usernameAvailability: {},
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    addFulfilledCases(
      builder,
      [me, getUserFromSession, authenticate, confirm2FA, googleSSO, update, confirmPayment],
      setField("user")
    );
    addFulfilledCases(
      builder,
      [
        getPreferences,
        toggleAvTracking,
        toggleEmailOptin,
        toggleFeatureFlags,
        updatePreferredCurrency,
        updatePreferredTwoFAMethod,
      ],
      setField("preferences")
    );
    addFulfilledCases(
      builder,
      [getProfilePicture, setProfilePicture],
      setField("profilepic")
    );
    builder
      .addCase(getAccountValues.fulfilled, setField("accountValues"))
      .addCase(setUsername.fulfilled, (state, action) => {
        state.user = { ...state.user, username: action.payload.username };
      })
      .addCase(checkUsernameAvailability.fulfilled, setField("usernameAvailability"))
      .addCase(checkUsernameAvailability.rejected, (state, action) => {
        state.usernameAvailability =
          action.payload?.response?.data || { available: false, result: "Error checking availability" };
      });
    addAsyncLifecycleCases(builder, {
      thunk: getPublicProfile,
      dataKey: "publicProfile",
      loadingKey: "publicProfileLoading",
      errorKey: "publicProfileError",
    });
    builder
      .addCase(logout.fulfilled, (state) => {
        state.user = null;
        state.preferences = null;
        state.profilepic = null;
        state.accountValues = null;
        state.publicProfile = {};
        state.usernameAvailability = {};
      })
      .addCase(expiredLogout.fulfilled, (state) => {
        state.user = null;
        state.preferences = null;
        state.profilepic = null;
        state.accountValues = null;
      });
  },
});

export default userSlice.reducer;
